import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ConsentField, Field, FormError, Honeypot, Segmented, SelectInput, SubmitButton, TextInput } from "@/components/inquiry/fields";
import { callbackSchema } from "@/components/inquiry/schemas";
import { useLeadSubmit } from "@/components/inquiry/useLeadSubmit";
import { CALLBACK_TIMES, CONCERNS } from "@/lib/leadLabels";

export const CallbackForm = ({ prefix = "callback" }) => {
  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm({
    resolver: zodResolver(callbackSchema),
    mode: "onTouched",
    defaultValues: { name: "", phone: "", callback_time: "sofort", callback_at: "", concern: "", consent: false, website: "" },
  });
  const { submit, error } = useLeadSubmit("callback");
  const time = watch("callback_time");

  return (
    <form onSubmit={handleSubmit((v) => submit(v))} noValidate className="relative space-y-4" data-testid={`${prefix}-form`}>
      <Honeypot register={register} />
      <Field label="Name" required htmlFor={`${prefix}-name`} error={errors.name?.message}>
        <TextInput id={`${prefix}-name`} autoComplete="name" invalid={!!errors.name} {...register("name")} data-testid={`${prefix}-name`} />
      </Field>
      <Field label="Telefon" required htmlFor={`${prefix}-phone`} error={errors.phone?.message}>
        <TextInput id={`${prefix}-phone`} type="tel" inputMode="tel" autoComplete="tel" placeholder="z. B. 0171 1234567" invalid={!!errors.phone} {...register("phone")} data-testid={`${prefix}-phone`} />
      </Field>
      <fieldset className="space-y-1.5">
        <legend className="mb-1.5 text-[13px] font-semibold text-brand-anthracite">Wunschzeit <span className="text-brand-blue">*</span></legend>
        <Segmented name="callback_time" options={CALLBACK_TIMES} register={register} prefix={`${prefix}-time`} />
      </fieldset>
      {time === "termin" && (
        <Field label="Datum & Uhrzeit" required htmlFor={`${prefix}-at`} error={errors.callback_at?.message}>
          <TextInput id={`${prefix}-at`} type="datetime-local" invalid={!!errors.callback_at} {...register("callback_at")} data-testid={`${prefix}-at`} />
        </Field>
      )}
      <Field label="Anliegen" htmlFor={`${prefix}-concern`}>
        <SelectInput id={`${prefix}-concern`} {...register("concern")} data-testid={`${prefix}-concern`}>
          <option value="">Bitte wählen</option>
          {CONCERNS.map((c) => <option key={c} value={c}>{c}</option>)}
        </SelectInput>
      </Field>
      <ConsentField id={`${prefix}-consent`} register={register} error={errors.consent?.message} />
      <FormError error={error} testId={`${prefix}-submit-error`} />
      <SubmitButton loading={isSubmitting} testId={`${prefix}-submit`}>Rückruf anfordern</SubmitButton>
    </form>
  );
};
